<template>
	<div
		class="ms-combobox flex ms-editor relative"
		:class="{ isValid: errorProvider.isValid }"
	>
		<div class="selected-options">
			<div v-if="isShowTextInput">
				<div
					class="selected-item"
					v-for="(item, index) in listSelectedItem"
					:key="index"
				>
					<div class="item-text">{{ item[displayField] }}</div>
					<div
						class="icon-input ms-mgl-8px"
						v-tooltip="{
							content: item.message,
							show: showTooltip(item),
							classes: `error`,
						}"
						v-show="item.isValid"
					>
						<div>
							<div class="mi mi-24 mi-red-tick"></div>
						</div>
					</div>
					<div
						class="item-icon mi-12 mi-new-v2 mr-2 mi-icon-v2-close-12 cursor-pointer"
						@click.stop="deSelect(item)"
					></div>
				</div>
			</div>
			<input
				ref="input"
				class="input"
				:placeholder="placeholder"
				v-model="internalText"
				v-on="listeners"
				:readonly="readonly"
				:class="{ readOnly: readonly }"
			/>
		</div>

		<div
			@click="expand(!expanded)"
			class="icon-combo--dropdown"
			:class="{ readOnly: readonly }"
		>
			<div :class="['mi-new-v2 mi-16 mi-icon-v2-arrow-dropdown']"></div>
		</div>
		<ms-combo-box-dropdown
			ref="dropdownPanel"
			v-if="expanded"
			class="ms-combo-multi-dropdown"
			:class="dropdownClass"
			:topx="dropdownTopx"
			:leftx="dropdownLeftx"
			:maxWidthx="dropdownMaxWidthx"
			:minWidthx="dropdownMinWidthx"
			:columnx="scaledColumns"
			:comboType="comboType"
			:emptyText="emptyText"
			@removeAll="removeAllSelected"
			:isShowUnSelectAll="
				listSelectedItem && listSelectedItem.length > 0 && getTotalData() > 0
			"
			:hasHeader="hasHeader"
			:serial="true"
			:isCustomEmpty="isCustomEmpty"
			:isEmptyDataSearch="getTotalData() <= 0"
			@addClick="addClick"
			:isActionAdd="true"
			:isShowRemoveAll="false"
		>
			<MsRecycleScroller
				ref="scroller"
				:style="styleScroller"
				:items="internalDataSource"
				:itemSize="itemSize"
				:keyField="keyField"
				:emitUpdate="true"
				:buffer="0"
				:visiableIndex="typeAheadPointer"
				@visible="onScrollerVisible"
				@update="onScrollerUpdate"
			>
				<template v-slot="{ item, index }">
					<ms-combo-box-item
						:comboType="comboType"
						:item="item"
						:columnx="scaledColumns"
						:valueField="valueField"
						:displayField="displayField"
						:class="{
							'ms-combobox-item--highlight': typeAheadPointer == index,
						}"
						@click="onItemClick(item, $event)"
						:serial="true"
						:rowIndex="index"
						:isLastItem="
							isHideLastRowBorderOnScroll &&
							index == internalDataSource.length - 1
						"
					></ms-combo-box-item>
				</template>
			</MsRecycleScroller>
		</ms-combo-box-dropdown>
	</div>
</template>

<script>
import MsComboBoxDropdown from './MsComboBoxDropdown.vue';
import MsComboBoxItem from './MsComboBoxItem.vue';
import MsRecycleScroller from '@/components/msvirtualscroller/MsRecycleScroller';
import commonFunc from '@/common/commonFunction.js';
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';

export default {
	name: 'MsAutoComboboxCompleteMulti',
	extends: msBaseComponent,
	components: { MsComboBoxDropdown, MsRecycleScroller, MsComboBoxItem },
	props: {
		value: {
			default: () => [],
		},
		placeholder: {
			default: null,
			type: [Number, String],
		},
		maxItemsDisplay: {
			default: 5,
			type: Number,
		},
		columns: {
			type: Array,
			default: () => [],
		},
		/**
		 * Trường làm value
		 * CreatedBy LTDAT 15.06.2020
		 */
		valueField: {
			type: String,
			default: null,
		},
		/**
		 * Trường làm text display
		 * CreatedBy LTDAT 15.06.2020
		 */
		displayField: {
			type: String,
			default: null,
		},
		//Dữ liệu của combobox
		data: {
			default: () => [],
			type: Array,
		},
		//Độ rộng của 1 item
		itemSize: {
			default: 36,
			type: Number,
		},
		//Chỉ nhận giá trị có trong danh sách
		forceSelection: {
			default: true,
			type: Boolean,
		},
		//Là combotree hay không
		isComboTree: {
			default: false,
			type: Boolean,
		},
		//Parent Field
		idProperty: {
			default: null,
			type: String,
		},
		//Field chứa parentID
		parentIdProperty: {
			default: 'ParentID',
			type: String,
		},
		//Không cho phép chọn trường là cha
		notSelectionParent: {
			default: false,
			type: Boolean,
		},
		//Độ rông của dropdown tính bằng px
		dropdownWidth: {
			default: null,
			type: [String, Number],
		},
		//Store xử lý dữ liệu trên liên quan đến data trong grid
		store: {
			default: null,
		},
		//Mode query lấy dữ liệu từ server hay client
		queryMode: {
			type: String,
			default: 'remote',
		},
		//Gán giá trị text lúc ban đầu
		initText: {
			default: null,
			type: [Number, String],
		},
		//Trạng thái có phân trang hay không
		pagination: {
			default: false,
			type: Boolean,
		},
		autoLoad: {
			default: false,
			type: Boolean,
		},
		keyField: {
			default: '__vKeyValue',
			type: String,
		},

		nameItem: {
			default: null,
			type: String,
		},

		//rule để validate từng giá trị trong multi
		rulesItem: {
			type: String,
			default: null,
		},
		/**
		 * Có sử dụng phép phím cách để lựa chọn item trong combobox hay không
		 */
		isKeySpace: {
			default: false,
			type: Boolean,
		},
		/**
		 * Có sử dụng phép phím tab để lựa chọn item trong combobox hay không
		 */
		isKeyTab: {
			default: false,
			type: Boolean,
		},
		/**
		 * Có sử dụng phép phím enter để lựa chọn item trong combobox hay không
		 */
		isKeyEnter: {
			default: false,
			type: Boolean,
		},
		hasHeader: {
			default: false,
			type: Boolean,
		},
		isShowTextInput: {
			default: false,
			type: Boolean,
		},
		emptyText: {
			default: null,
			type: String,
		},
		//Custom lại UI hiển thị của combobox k có dữ liệu
		isCustomEmpty: {
			default: null,
			type: Object,
		},
		//Căn đít (mép phải) dropdown thẳng với mép phải combobox thay vì mép trái
		//Dùng cho TH dropdownWidth > width combobox, mặc định false để không đổi hành vi nơi khác đang dùng component này
		alignDropdownRight: {
			default: false,
			type: Boolean,
		},
		/**
		 * Cấu hình các tuỳ chọn chung của dropdown combobox (dạng object để dễ mở rộng sau)
		 * @params hideLastRowBorderOnScroll Bỏ border-bottom của item cuối khi dropdown có scroll dọc, tránh đè lên border khung bao ngoài .combo-dropdown-panel
		 */
		dropdownOptions: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		listeners() {
			const me = this;
			return {
				input: (event) => me.onInput(event),
				focus: (event) => me.onFocus(event),
				change: (event) => me.onChange(event),
				blur: (event) => me.onBlur(event),
				keydown: (event) => me.onKeydown(event),
			};
		},
		//Tính độ rộng của dropdown combobox để scroll
		styleScroller() {
			const me = this;
			return { 'max-height': me.maxItemsDisplay * me.itemSize + 'px' };
		},

		/**
		 * Chỉ ẩn border-bottom item cuối khi cha bật dropdownOptions.hideLastRowBorderOnScroll VÀ dropdown đang có scroll dọc
		 * (số item vượt quá số item hiển thị tối đa)
		 */
		isHideLastRowBorderOnScroll() {
			const me = this;
			return !!(
				me.dropdownOptions &&
				me.dropdownOptions.hideLastRowBorderOnScroll &&
				me.internalDataSource &&
				me.internalDataSource.length > me.maxItemsDisplay
			);
		},

		dropdownClass() {
			const me = this,
				vnodeData = me.$vnode && me.$vnode.data;
			if (!vnodeData) return null;
			return [vnodeData.staticClass, vnodeData.class].filter(Boolean).join(' ');
		},

		scaledColumns() {
			const me = this;
			if (!me.columns || me.columns.length === 0) return me.columns;

			const reservedWidth = 40 + 56; // cột STT (serial) + cột tick (.selected-container)
			const panelWidth = me.dropdownMinWidthx;
			const configuredWidth = me.columns.reduce(
				(sum, col) => sum + (col.width || 0),
				0
			);

			if (!panelWidth || !configuredWidth) return me.columns;

			const availableWidth = panelWidth - reservedWidth;
			const ratio = availableWidth / configuredWidth;

			return me.columns.map((col) => ({
				...col,
				width: col.width ? Math.round(col.width * ratio) : col.width,
			}));
		},
	},
	data() {
		const me = this;
		me.initStaticData();
		return {
			internalText: '',
			expanded: false,
			dropdownTopx: 0,
			dropdownLeftx: 0,
			dropdownMinWidthx: 0,
			dropdownMaxWidthx: 0,
			internalSelectedItem: null,
			typeAheadPointer: -1,
			listSelectedItem: [],
			currentSkip: 0,
			focused: false,
			autoFocus: false,
			isChangeDataSelected: false,
		};
	},
	//Hàm khởi tạo dữ liệu hook func
	created() {
		const me = this;
		me.initCombo();
		me.initData();
		me.setInitText();
		if (me.autoLoad) {
			me.doQueryInternal(null, false);
		}
	},
	mounted() {
		const me = this;
		//Debounce query để delay load
		if (me.queryMode != 'remote') {
			me.internalQueryDelay = 20;
		}
		me.doQuery = _.debounce(me.doQueryInternal, me.internalQueryDelay);
		if (me.store) {
			me.store.pageAppend = true;
		}
	},
	beforeDestroy() {
		const me = this;
		document.removeEventListener('click', me.click_out);
	},
	methods: {
		showTooltip(item) {
			const me = this;
			let itemError = [...me.listSelectedItem]
				.reverse()
				.find((x) => x.isValid == true);
			if (itemError && itemError[me.valueField] == item[me.valueField]) {
				return me.focused;
			} else {
				return false;
			}
		},

		removeAllSelected() {
			let me = this;
			me.internalText = '';
			setTimeout(function () {
				if (me.listSelectedItem && me.listSelectedItem.length > 0) {
					me.listSelectedItem.forEach((item) => {
						item.__multiSelected = false;
					});
					me.listSelectedItem.removeAll();
					me.value.removeAll();
					me.$emit('removeAllSelect');
				}
			}, 300);
		},
		deSelect(item, isParent = false) {
			let me = this,
				VModel = me.value;
			//Gọi hàm từ hàm cha
			if (isParent) {
				let index = me.listSelectedItem.findIndex((x) => {
					return item[me.valueField] == x[me.valueField];
				});
				if (index >= 0) {
					me.listSelectedItem.splice(index, 1);
				}
			} else {
				me.listSelectedItem.remove(item);
			}

			let exist = VModel.find((x) => x[me.valueField] == item[me.valueField]);
			if (exist) {
				VModel.remove(exist);
			}
			item.__multiSelected = false;

			//Focus vào input trên combobox nếu cần
			me.autoFocusInput();
		},
		/**
		 * Kiểm tra scroll đã đến bản ghi cuối cùng hay chưa
		 * Nếu load theo kiểu phân trang và số bản ghi trong combo nhỏ hơn tổng số bản ghi thi load tiếp dữ liệu vào store
		 * @param start: vị trí bắt đầu của view trong vitual scroll
		 * @param end: vị trí kết thúc của view trong vitual scroll
		 * Created by LTDAT(30.06.2020)
		 *  */
		async onScrollerUpdate(start, end) {
			const me = this;
			if (me.internalDataSource && end == me.internalDataSource.length) {
				let skip = Math.floor(me.internalDataSource.length / 20) * 20;
				if (skip > me.currentSkip) {
					let payload = {};
					if (me.pagination) {
						payload.Skip = skip;
						payload.Take = 20;
						payload.pageAppend = false;
						payload.SearchText = me.getQueryString();
					}
					me.currentSkip = skip;
					await commonFunc.emitPromise(me, 'loadData', payload);
					me.setItemSelectedValue(me.value);
				}
			}
		},
		/**
		 * Set giá trị hiện thị ban đầu cho combobox khi combo chưa có dữ liệu
		 * Created by LTDAT(25.06.2020)
		 */
		setInitText() {
			const me = this;
			me.internalText = me.initText;
		},
		/**
		 * Thực hiện query dữ liệu, có thể từ local hoặc remote tùy theo cấu hình
		 * CreatedBy LTDAT 11/12/2019
		 */
		doQueryInternal(searchString, expand = true, skip = 0) {
			let me = this,
				event = { preventDefault: false, sender: me },
				queryString = searchString != null ? searchString : me.getQueryString();
			me.$emit('beforeQuery', event);
			if (event.preventDefault) {
				return false;
			}
			if (me.lastQueryString == queryString) {
				me.expand(expand);
			} else {
				me.lastQueryString = queryString;
				me.querying = true;
				me.typeAheadPointer = -1;
				if (me.queryMode === 'remote' || me.store.remoteFilter) {
					me.doRemoteQuery(queryString, expand, skip).then((x) => {
						commonFunc.genVKeyValue(me.internalDataSource);
						me.afterQuery(expand);
						//Nếu đã có danh sách đã chọn thì gán lại giá trị đánh dấu cờ đã tích chọn
						if (me.listSelectedItem.length > 0) {
							me.internalDataSource.forEach((item) => {
								if (me.listSelectedItem.find((x) => x.Id == item.Id)) {
									item.__multiSelected = true;
								}
							});
						}
					});
				} else {
					me.doLocalQuery(queryString).then((x) => me.afterQuery(expand));
				}
			}
		},
		/**
		 * Xử lý sau khi query xong dữ liệu
		 * CreatedBy LTDAT 24.06.2020
		 */
		afterQuery(expand) {
			const me = this;
			me.expand(expand);
			me.typeAheadPointer = me.filterIndexItemByText();
		},
		/**
		 * Query dữ liệu api
		 * CreatedBy LTDAT 24.06.2020
		 */
		doRemoteQuery(queryString, expand, skip = 0) {
			//Build filter,
			let me = this,
				filters = [],
				filterFields = me.filterFields;
			return new Promise(async (resolve, reject) => {
				if (queryString) {
					for (const key in filterFields) {
						if (filterFields.hasOwnProperty(key)) {
							const f = filterFields[key];
							let filter = {
								property: key,
								value: queryString,
								operator: f,
								operand: 'or',
							};
							filters.push(filter);
						}
					}
				}
				let payload = {};
				if (me.pagination) {
					payload.Skip = skip;
					payload.Take = 20;
					payload.pageAppend = false;
					payload.SearchText = queryString;
				}
				me.currentSkip = 0;
				await commonFunc.emitPromise(me, 'loadData', payload);
				me.setItemSelectedValue(me.value);
			});
		},

		/**
		 * Query dữ liệu local
		 * CreatedBy LTDAT 24.06.2020
		 */
		doLocalQuery(queryString) {
			let me = this,
				store = me.store;

			return new Promise((resolve, reject) => {
				//Kiểm xem store đã load dữ liệu chưa, nếu chưa thì load lần đầu
				let p;
				if (me.autoLoad && store && !store._loaded && store.getCount() == 0) {
					let proxy = store.proxy;
					if (proxy && proxy.type === 'cache') {
						p = store.load();
					}
				}
				// if (store && store.proxy && store.proxy.type === 'cache') {
				// 	p = clientDatabase.fetchKey(store.proxy.keyCache).then(res => {
				// 		//Nếu cache thay đổi thì load lại
				// 		if (res) {
				// 			store.load();
				// 		}
				// 	});
				// }
				p ? p.then(resolve, reject) : resolve(false);
			}).then(() => {
				me.loading = false;
			});
		},
		/**
		 * Lấy chuỗi cần query, trường hợp number thì lấy value bỏ qua ký tự phân cách
		 * CreatedBy LTDAT 11/12/2019
		 */
		getQueryString() {
			return (this.internalText || '').trim();
		},
		//Click ra ngoài combo đóng combo lại
		//Created by LTDAT 18.06.2020
		click_out(e) {
			const me = this;
			if (
				!commonFunc.hasParent(e.target, me.$el) &&
				!commonFunc.hasParent(e.target, me.$refs.dropdownPanel.$el)
			) {
				me.expand(false);
			}
		},
		//Reset lại các giá trị trong combobox
		reset() {
			const me = this;
			me.internalText = '';
			me.internalSelectedItem = null;
			me.typeAheadPointer = -1;
			me.internalValue = null;
			// me.$emit('input', me.internalValue);
		},
		setInternalText(value) {
			const me = this;
			me.internalText = value;
		},
		setValue(value) {
			const me = this;
			me.internalValue = value;
			me.$emit('input', me.internalValue);
		},
		//Sự kiện nhập liệu trên input
		//Created by LTDAT (16.06.2020)
		onInput(e) {
			const me = this;
			if (!me.expanded) {
				me.expand(true);
			}
			if (!me.internalText) {
				if (me.internalValue) {
					let metaData = {
						oldData: me.internalSelectedItem,
						newData: null,
					};
					me.$emit('selected', metaData);
				}
				me.reset();
			}
			if (me.queryMode == 'remote') {
				me.doQuery(me.internalText, true);
			} else {
				me.typeAheadPointer = me.filterIndexItemByText();
			}
		},
		//Sự kiện focus vào input
		//Created by LTDAT (16.06.2020)
		onFocus(e) {
			const me = this;
			me.focused = true;
			me.$emit('focus', e);
		},
		//Sự kiện change input
		//Created by LTDAT (16.06.2020)
		onChange(e) {
			const me = this;
			if (me.internalText && me.internalText.trim()) {
				if (me.internalDataSource && me.internalDataSource.length > 0) {
					let keyByData = _.keyBy(me.internalDataSource, me.valueField);
					if (keyByData.hasOwnProperty(me.internalText)) {
						me.setInternalItem(keyByData[me.internalText]);
					} else {
						let objNew = {};
						me.$set(objNew, me.valueField, me.internalText);
						me.setInternalItem(objNew);
					}
				}
			}
		},
		//Sự kiện blur input
		//Created by LTDAT (16.06.2020)
		onBlur(e) {
			const me = this;
			me.focused = false;
			me.$emit('blur', e);
		},
		//Sự kiện keydown input
		//Created by LTDAT (16.06.2020)
		onKeydown(e) {
			const me = this;
			me.focused = false;
			switch (e.which) {
				case 40: //Mũi tên xuống
					{
						if (!me.expanded) {
							me.expand(true);
						} else if (me.typeAheadPointer < me.getTotalData() - 1) {
							if (me.notSelectionParent) {
								let typeAheadPointerNext = me.typeAheadPointer + 1;
								for (let i = typeAheadPointerNext; i < me.getTotalData(); i++) {
									me.typeAheadPointer++;
									me.adjustScroll(typeAheadPointerNext);
									if (!me.internalDataSource[i].isParent) {
										break;
									}
								}
							} else {
								me.typeAheadPointer++;
								me.adjustScroll();
							}
						}
					}
					break;
				case 38: //Mũi tên lên
					{
						if (me.expanded) {
							if (me.typeAheadPointer > 0) {
								if (me.notSelectionParent) {
									let typeAheadPointerPre = me.typeAheadPointer - 1;
									for (let i = typeAheadPointerPre; i > 0; i--) {
										me.typeAheadPointer--;
										me.adjustScroll(me.typeAheadPointer);
										if (!me.internalDataSource[i].isParent) {
											break;
										}
									}
								} else {
									me.typeAheadPointer--;
									me.adjustScroll();
								}
							}
						}
					}
					break;
				case 13: //Enter
					{
						event.preventDefault();
						//Chỉ cho phép sự kiện enter khi mở combox và có chọn item
						if (me.typeAheadPointer >= 0 && me.expanded) {
							me.setInternalItem(me.internalDataSource[me.typeAheadPointer]);
							me.internalText = null;
							me.autoFocusInput();
						}
						me.expand(false);
					}
					break;
			}
		},
		getTotalData() {
			const me = this;
			return me.internalDataSource.length;
		},
		//Bôi màu hightlight cho item
		doHightlightItem() {
			const me = this;
			if (me.internalDataSource) {
				if (me.internalDataSource.length > 0) {
					if (me.internalValue != null && me.internalValue != undefined) {
						//Trước khi load tính toán lại typeAheadPointer nếu cần thiết để scroll di chuyển về dúng vị trí khi show scroller lên
						//Tìm vị trí selectedItem trong source, không lấy selectedIndex vì có thể không chính xác khi source thay đổi
						let index = _.findIndex(
							me.internalDataSource,
							(item) => item[me.valueField] === me.internalValue
						);
						me.typeAheadPointer = index;
					}
				}
			}
		},
		//Tìm kiếm item trong list
		//Created by LTDAT(16.06.2020)
		filterIndexItemByText() {
			const me = this;
			let filters = me.filterFields,
				value = me.internalText,
				index = -1;
			if (filters) {
				index = me.internalDataSource.findIndex((item, _index) => {
					let ret = false;
					for (const key in filters) {
						if (filters.hasOwnProperty(key)) {
							const s = filters[key];
							if (s == 'contains') {
								ret =
									item[key] &&
									item[key].toString() &&
									item[key]
										.toString()
										.toLowerCase()
										.contains(value.toLowerCase());
							} else {
								ret =
									item[key] &&
									item[key].toString() &&
									item[key]
										.toString()
										.toLowerCase()
										.startsWith(value.toLowerCase());
							}
							if (ret) {
								break;
							}
						}
					}
					return ret;
				});
			}
			me.adjustScroll();
			return index;
		},
		//Lấy cột filter để tìm kiếm local
		//Created by LTDAT 16.06.2020
		getFilterFields() {
			let filter = {};

			if (this.columns && this.columns.length > 0) {
				for (let i = 0; i < this.columns.length; i++) {
					const col = this.columns[i];
					if (!col.filterOperator) {
						col.filterOperator = 'contains';
					}
					if (col.dataField && col.filterOperator) {
						if (this.filterColumns && this.filterColumns.length > 0) {
							this.filterColumns.forEach((e) => {
								if (!filter.hasOwnProperty(e)) {
									filter[e] = col.filterOperator;
								}
							});
						} else {
							filter[col.dataField] = col.filterOperator;
						}
					}
				}
			} else {
				filter[this.displayField] = 'contains';
			}
			return filter;
		},
		//Lấy element scroll
		//Created by LTDAT (16.06.2020)
		getScroller() {
			if (this.expanded) {
				return this.$refs['scroller'];
			}
			return null;
		},
		/**
		 * Di chuyển view đến bản ghi nếu cần
		 * @param {Bản ghi cần view} index
		 * CreatedBy LTDAT 16.06.2020
		 */
		adjustScroll(typeAheadPointer = this.typeAheadPointer) {
			let scroller = this.getScroller();
			if (scroller) {
				scroller.scrollToItem(typeAheadPointer, true);
			}
		},
		onScrollerVisible() {
			const me = this;
			me.adjustScroll();
		},

		//Hàm xử lý khi chọn item trên dropdown
		//Created by LTDAT(16.06.2020)
		onItemClick(item, event) {
			const me = this;
			me.setInternalItem(item);
			//Reset dữ liệu tìm kiếm trong combobbox
			me.internalText = null;
			//Focus lại vào ô combobox
			me.autoFocus = true;
			me.autoFocusInput();
			me.doQueryInternal(null, true);
		},
		//Set giá trị được chọn
		setInternalItem: _.debounce(function (item) {
			let me = this;
			if (me.notSelectionParent && item.isParent) {
				return;
			}

			let metaData = {
				oldData: me.internalSelectedItem,
				newData: item,
				obdListData: me.listSelectedItem,
				newListData: [...me.listSelectedItem, item],
			};
			me.internalSelectedItem = item;
			me.internalValue = item[me.valueField];
			let itemInLists = me.listSelectedItem.find((_item) => {
				return _item[me.valueField] == item[me.valueField];
			});
			let VModel = me.value;
			if (!VModel) {
				VModel = [];
			}
			if (itemInLists) {
				let exist = VModel.find((x) => x[me.valueField] == me.internalValue);
				if (exist) {
					VModel.remove(exist);
					item.__multiSelected = false;
				}
			} else {
				let objNew = {};
				me.$set(objNew, me.valueField, me.internalValue);
				//Validate giá trị
				let validate = me.validateInput(objNew);
				if (validate && validate.isValid) {
					objNew.isValid = validate.isValid;
					objNew.message = validate.message;
				}
				VModel.push(objNew);
				item.__multiSelected = true;
			}
			me.$emit('input', VModel);
			// me.internalText = null;
			// me.expand(false);
			me.$emit('selected', metaData);

			me.$emit('updateListSelected', item);

			me.firstExpand = true;
		}, 200),
		//Tìm vị trị của item trong data
		findIndexItem(item) {
			const me = this;
			return me.internalDataSource.findIndex((_item) => {
				return _item == item;
			});
		},
		//Khởi tạo dữ liệu tĩnh mặc định
		initStaticData() {
			const me = this;
			me.comboType = 1;
			me.internalDataSource = [];
			me.internalQueryDelay = 200;
			me.filterFields = me.getFilterFields();
			me.focused = false;
			me.internalValue = null;
			me.firstExpand = true;
		},
		//Khởi tạo dữ liệu
		initData() {
			const me = this;
			if (me.store) {
				me.internalDataSource = me.store.data.items;
			} else {
				me.internalDataSource = me.data;
			}
			commonFunc.genVKeyValue(me.internalDataSource);
			//Nếu là combo dạng tree
			if (me.comboType == 3) {
				let dataTree = commonFunc.nomalizeDataTree(
					me.internalDataSource,
					me.idProperty,
					me.parentIdProperty
				);
				me.internalDataSource = commonFunc.getBodyData(dataTree, true);
			}
		},
		/**
		 * Khởi tạo combo
		 *
		 * @author hngiap - 01.09.2019
		 * 1 là combo không có columns (ComboEditor)
		 * 2 là combo có columns
		 * 3 là combo tree
		 */
		initCombo() {
			const me = this;
			if (me.isComboTree) {
				me.comboType = 3;
			} else if (me.columns && me.columns.length !== 0) {
				me.comboType = 2;
			} else {
				me.comboType = 1;
			}
		},
		//Đóng mở combobox
		expand(mode = !this.expanded) {
			const me = this;
			if (me.firstExpand) {
				if (me.queryMode == 'remote') {
					me.firstExpand = false;
					me.doQueryInternal(null, true);
				}
			}
			if (mode == true) {
				me.$emit('beforeExpand');
				document.addEventListener('click', me.click_out);
			} else {
				document.removeEventListener('click', me.click_out);
			}
			me.expanded = mode;
			me.doHightlightItem();
			me.$refs.input.focus();
			me.changeDropdownPosition();
			// me.setItemSelectedValue(me.value);
		},
		/**
		 * Hàm set vị trí cho dropdown menu khi expand
		 * TODO: Chưa xử lý khi có scroll
		 */
		changeDropdownPosition() {
			let me = this,
				comboEl = me.$el,
				comboElRect = comboEl.getBoundingClientRect(),
				comboMenuEl = me.$el;

			let windowWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;

			let windowHeight =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;

			me.dropdownTopx = comboElRect.top + comboElRect.height + 2;
			me.dropdownMaxWidthx = me.dropdownMinWidthx = me.dropdownWidth
				? me.dropdownWidth
				: comboElRect.width;

			if (me.alignDropdownRight) {
				// Căn đít (mép phải) dropdown thẳng với mép phải combobox
				me.dropdownLeftx = comboElRect.right - me.dropdownMaxWidthx;
				if (me.dropdownLeftx < 0) {
					me.dropdownLeftx = 0;
				}
			} else {
				me.dropdownLeftx = comboElRect.left;
				// Nếu chạm phải thì align sang trái
				if (comboElRect.left + comboMenuEl.offsetWidth > windowWidth) {
					me.dropdownLeftx = comboElRect.right - comboMenuEl.offsetWidth;
				}
			}

			// Nếu chạm bottom thì align top
			if (
				comboElRect.bottom + me.itemSize * me.maxItemsDisplay + 2 >
				windowHeight
			) {
				me.dropdownTopx =
					comboElRect.top -
					(me.itemSize *
						Math.min(me.maxItemsDisplay, me.internalDataSource.length) +
						4);
			}
		},
		setItemSelectedValue(newVal) {
			const me = this;
			if (newVal) {
				if (Array.isArray(newVal)) {
					me.listSelectedItem = [];
					newVal.forEach((item) => {
						me.internalValue = item[me.valueField];
						me.doHightlightItem();
						if (me.typeAheadPointer >= 0) {
							me.internalDataSource[me.typeAheadPointer].__multiSelected = true;
							me.listSelectedItem.push(
								me.internalDataSource[me.typeAheadPointer]
							);
						}
					});
				}
			} else {
				me.reset();
			}
		},

		validate() {
			const me = this;
			if (me.disabled) {
				me.errorProvider = {};
				return me.errorProvider;
			}
			if (me.listSelectedItem.length > 0) {
				me.listSelectedItem.forEach((element) => {
					me.validateInput(element);
				});
			}
			if (me.errorProvider.length > 0) {
				return me.errorProvider;
			} else if (me.listSelectedItem.find((x) => x.isValid == true)) {
				return me.listSelectedItem;
			} else {
				return {};
			}
		},

		validateInput(data) {
			const me = this;
			let listRules = [],
				rulesValidate = null,
				ret = false;
			if (me.rulesItem) {
				listRules = me.rulesItem.split('|');
			}
			for (let i = 0; i < listRules.length; i++) {
				ret = !me.validateRule(listRules[i], data[me.valueField], null);
				if (ret) {
					rulesValidate = listRules[i];
					break;
				}
			}
			if (ret) {
				if (me.$t('i18nValidate.messages')[rulesValidate]) {
					me.$set(
						data,
						'message',
						me
							.$t('i18nValidate.messages')
							[rulesValidate](me.nameItem ? me.nameItem : me.name)
					);
				}
				me.$set(data, 'isValid', true);
			} else {
				me.$set(data, 'isValid', false);
				me.$set(data, 'message', null);
			}
			me.$set(data, 'element', me.$refs.input);
			return data;
		},
		/**
		 * Hàm sử lí việc autoFocus ô input
		 */
		autoFocusInput(e) {
			const me = this;
			//Focus vào ô input
			if (me.autoFocus) {
				me.$ms.commonFunc.focusFirstControl(me.$el);
			}
		},

		addClick() {
			this.$emit('addClick');
		},
		/**
		 * Hàm reset dữ liệu tìm kiếm trên combobox
		 */
		resetDataCombobox() {
			const me = this;
			//Reset dữ liệu tìm kiếm trong combobbox
			me.internalText = null;
			me.doQueryInternal(null, true);
		},
	},
	watch: {
		/**
		 * Set lại giá trị hiển thị khi giá trị của biến initText thay đổi
		 */
		initText: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.setInitText(newVal);
			},
		},
		/**
		 * Kiểm tra nếu text hiện thị thay đổi thi validate
		 */
		internalText: {
			handler(newVal, oldVal) {
				const me = this;
				// me.validate(newVal);
				// me.$emit('input',newVal);
			},
		},
		/**
		 * Nếu giá trị VModel của combo thay đổi thì gán lại giá trị mới và select vào item tương ứng có trong data
		 */
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.setItemSelectedValue(newVal);
				me.isChangeDataSelected = !me.isChangeDataSelected;
			},
		},
	},
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_sm-variables.scss';
@import '@/assets/scss/components/msCombo.scss';
.selected-options {
	display: flex;
	flex-basis: 100%;
	flex-grow: 1;
	flex-wrap: wrap;

	.selected-item {
		display: flex;
		align-items: center;
		border-radius: 6px;
		background: var(--color-neutral-200);
		border: 1px solid var(--ms-color-border);
		padding: 4px 8px;
		margin: 4px 4px 4px 12px;
		max-width: calc(100% - 4px);
		height: 24px;
		.item-text {
			font-size: $font-size-medium;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		.item-icon {
			margin-left: 6px;
		}
	}

	.selected-item:not(:last-child) {
		margin-right: 2px;
	}

	.ms-input {
		border: none;
		font-size: $font-size-body-new;
		padding: 5px 10px;
		padding-right: unset;
		text-overflow: ellipsis;
		background-color: transparent;
		display: flex;
		flex: 1;
	}
	.ms-input::placeholder {
		font-size: $font-size-medium;
		font-style: italic;
		color: $grey;
	}
}
// Ẩn border-bottom item cuối view nhìn / cuối danh sách trong dropdown chọn nhiều (giống grid).
// Virtual scroll wrap mỗi item trong 1 .vue-recycle-scroller__item-view riêng nên :last-child trên item không áp dụng được.
// Chuyển separator sang border-top của item-view kế tiếp → item cuối view nhìn / cuối danh sách không còn line dưới.
// Đặt ngay trong component để mọi form dùng ms-auto-combobox-complete-multi tự áp dụng, không cần CSS lặp lại ở từng view.
.ms-combo-multi-dropdown.combo-dropdown-panel {
	.combobox-item {
		border-bottom: none;

		.combobox-item-td,
		.ms-td-serial,
		.selected-container {
			border-bottom: none;
		}
	}

	.vue-recycle-scroller__item-view + .vue-recycle-scroller__item-view {
		border-top: 1px solid var(--ms-color-border);
	}
}
</style>